<template>
    <transition name="slide-fade">
        <div class="modal" :class="{ 'open': open }" v-if="open">
            <div class="modal-content font-main relative">
                <div class="bg-white w-full rounded-xl p-3">
                    <div class="text-center text-14 text-a-gray-555555 mb-4">
                        เลขที่รับแจ้งอุบัติเหตุ
                    </div>
                    <div class="text-center text-xl text-a-orange-fe5000 font-bold mb-4">
                        {{ claimSerialNo }}
                    </div>
                    <div class="text-center text-14 text-a-gray-555555 pb-1.5 leading-relaxed">
                        ธนชาตประกันภัยได้รับข้อมูลของท่านแล้ว<br />
                        เจ้าหน้าที่จะติดต่อกลับก่อนถึงวันนัดหมาย
                    </div>
                </div>
                <button type="button" class="outline-none appearance-none bg-none absolute top-2 right-2" @click="hide()">
                    <img src="@/assets/icon/ic-close.svg" alt=""/>
                </button>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "AppointmentSuccessModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function () {
        return {
            open: false,

            message: '',
            busModal: null,
            claimSerialNo: ""
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function () {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function (config) {
            this.message = config.msg;
            this.claimSerialNo = config.claimSerialNo

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
            this.controller.sendCallbackClose()
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";

.modal {
    @extend %modal;
    @apply px-4;
    .modal-content{
        width: 100%;
        max-width: 360px;
        // @apply mx-auto;
    }
}
</style>
